import styled from 'styled-components';
import { colors } from '../styles/variables';

const OrderItemView = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid ${colors.gray300};
  border-radius: 4px;
  p {
    margin: 0;
  }
  .name {
    font-size: 16px;
    line-height: 22px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .date {
    font-size: 12px;
  }
  .mute {
    margin-bottom: 0;
    font-size: 12px;
    color: ${colors.gray600};
    span, strong {
      margin-right: 8px;
    }
  }
  .number-select-pc {
    margin: 4px 0;
    display: flex;
    & > div {
      margin-right: 8px;
    }
    p {
      font-size: 12px;
      margin: 0;
    }
  }
  .number-select-sp {
    margin: 4px 0;
    display: flex;
    flex-flow: wrap;
    & > div {
      margin-bottom: 10px;
      width: 140px;
    }
    p {
      font-size: 12px;
      margin: 0;
    }
  }
  .trash {
    display: block;
    border-radius: 4px;
    text-align: center;
    align-self: end;
    color: ${colors.gray600};
    &:hover {
      color: ${colors.gray800};
    }
  }
`;

export default OrderItemView;
